
<!-- main component container -->
<div id="welcome-page-container">
  <!-- Row 1 -->
  <div class="row">
    <div class="agent-portal-content-spacing">
      <h1 class="agent-portal-title hide-on-tablet agent-portal-hide-on-mobile">See the John Hancock eApp in action!</h1>
      <h2 class="agent-portal-title  mobile-content mobile-center-text">See the John Hancock eApp in action!</h2>
    </div>
  </div>
  <div class="wp-main">
    <div class="agent-portal-content-spacing">
      <p class="header-5">
        Take a “test” drive of the John Hancock eApp for a quick initiation into this powerful application platform. Becoming familiar with its key features through this simulated experience (e.g., seeing how you can share specific application sections with your customers) will assist you in anticipating potential questions and help you move through the application faster. 
      <br><br><br>
      While the simulation is quite similar to the real experience, please note a few key differences needed to facilitate the test:
    <br>  <br>
      </p>

      
        <ul class="header-5 welcome-page-ul  jh-font-family">
          <li class=" welcome-page-list-item jh-font-family ">
            The customer’s name and basic demographic information will be pre-filled with sample information and cannot be edited.
          </li>
          <li class=" welcome-page-list-item jh-font-family"> You will assume the role of both agent and customer during the test experience, giving you insight into the steps customers will be asked to complete in a real John Hancock eApp submission.  </li>
          <li class=" welcome-page-list-item jh-font-family"> Your test application will be available for 48 hours from the time it was initiated. </li>
        </ul>
      
    </div>

    <div class="wp-main-right agent-portal-content-spacing">
      <div class="agent-portal-content-spacing">
        <p class="header-5">
          <br>
          When you’re ready to begin, click the “Start test application” button below. If you would like additional information about this test experience, refer to <a [href]="FAQ_URL">this FAQ</a>. 
          <br><br>
          As new features and enhancements are made to the John Hancock eApp, we encourage you to come back to the test experience to become familiar with the updates.      
        </p>
      </div>
    </div>
  </div>
  <div class="agent-portal-content-spacing" style="display: flex;">
    <button class="primary-cta-btn jh-font-family" (click)=" startDemoApplication() " [disabled]=!isLoggedInViaSalesHub>
      Start test application
    </button>
  </div>
  <div class="row" *ngIf=" processing ">
    <!-- spinner -->
    <div class="spinner-wrapper text-center mini-portal-agent-app-spinner" [ngClass]="{'show': processing || startNewApp}">
      <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
    </div><!-- /spinner -->
  </div>
  <!-- end row spinner -->

  <!-- Row 9 -->
  <div class="row agent-portal-content-spacing">
    <div *ngIf="!isLoggedInViaSalesHub" class=" welcome-page-secondary-text-wrapper " style="color:red">
        Error: please login via SalesHub
    </div>
  </div>


</div>
